import { useEffect } from 'react';

// La landing es una copia estática en public/taller-negociacion/.
// En Firebase se sirve directamente; esta ruta cubre el caso en que cargue la app (ej. en local).
const TallerNegociacion = () => {
  useEffect(() => {
    window.location.replace('/taller-negociacion/index.html');
  }, []);
  return null;
};

export default TallerNegociacion;
